import { Component } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';

@Component({
  selector: 'itl-order-articledata-popover',
  template: `
    <ion-list>
      <ion-item (click)="toggleAllChecked()" style="cursor: pointer;">
        <span *ngIf="allChecked">Alle abwählen</span>
        <span *ngIf="!allChecked">Alle auswählen</span>
      </ion-item>
      <ion-item (click)="setRecommendation()" style="cursor: pointer;">Alle Empfehlungen setzen</ion-item>
    </ion-list>
  `,
})
export class OrderArticledataPopoverComponent {
  public allChecked: boolean;
  constructor(private _popOverController: PopoverController, private _navParms: NavParams) {
    this.allChecked = this._navParms.get('allChecked');
  }

  async close() {
    await this._popOverController.dismiss().catch(error => console.log(error));
  }
  async toggleAllChecked() {
    await this._popOverController
      .dismiss({
        allCheckedToggled: true,
      })
      .catch(error => console.log(error));
  }
  async setRecommendation() {
    await this._popOverController
      .dismiss({
        setRecommendation: true,
      })
      .catch(error => console.log(error));
  }
}
